import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { Link } from "react-router-dom";

const FixedIncomeProducts = () => {
  useEffect(() => {
    if (window.jQuery && window.$.fn.tab) {
      window.$(".tab1").tab();
      window.$(".tab2").tab({ trigger_event_type: "mouseover" });
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fixed-income-page">
      <SEO
        title="Fixed Income Products"
        description="Stable returns through bonds and income securities tailored to your risk profile. Predictive income streams and capital preservation for your portfolio."
      />

      <section className="service-banner">
        <img
          src="/images/banners/fixed-income-banner.avif"
          alt="Fixed Income Products Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/fixed-income-mobile-banner.avif"
          alt="Fixed Income Products Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Fixed Income <span>Products</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              Fixed income instruments play a critical role in portfolio
              construction by offering relative stability, predictable income
              streams, and capital preservation characteristics. Our Fixed
              Income platform provides access to a carefully evaluated range of
              debt instruments designed to support income generation, risk
              balancing, and long-term financial planning objectives.
            </p>
            <p>
              Whether you are a conservative investor seeking stable returns, a
              retiree planning periodic income, or a portfolio manager aiming to
              reduce volatility exposure, fixed income allocation forms an
              essential pillar of disciplined wealth management.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/fixed-offer.avif"
              alt="Fixed Income Products and Services Overview"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt=""
          className="offer-bg"
          aria-hidden="true"
        />
      </section>

      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Preserve and grow your capital through carefully structured income
              solutions. Designed to deliver stability, consistency, and
              dependable returns.
            </p>
            <img
              src="/images/services/fixed-highlight.png"
              alt="Fixed Income Key Highlights Graphic"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Corporate Bonds & NCDs</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Tax-efficient debt instruments</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Credit quality evaluation support</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Portfolio diversification strategy</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Fixed income instruments are subject to credit
            risk, interest rate risk, and liquidity risk. Returns are not
            guaranteed unless specifically stated in the offer document.
          </p>
        </div>
      </section>

      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="Investment Mobile App Preview"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default FixedIncomeProducts;
